<div
  class="filter-body"
  [ngStyle]="{ 'text-align': currLang == 'en' ? 'left' : 'right' }"
>
  <div
    #filtermenu
    *ngIf="grades.length > 0"
    [class]="
      listType !== 'enroll-bus-students'
        ? 'filter-menu'
        : 'filter-menu-students'
    "
  >
    <!-- staff Filters -->
    <div *ngIf="listType !== 'enroll-bus-students'" class="close-btn">
      <span class="filter-word">{{ "filter.filter" | translate }}</span>
      <svg
        (click)="closeFilter()"
        xmlns="http://www.w3.org/2000/svg"
        width="13.41"
        height="15.41"
        viewBox="0 0 13.41 15.41"
        [ngStyle]="{
          'margin-left': currLang == 'ar' ? '1rem' : 'unset',
          float: currLang == 'ar' ? 'left' : 'right'
        }"
      >
        <g
          id="Group_4784"
          data-name="Group 4784"
          transform="translate(76.205 -1168.795) rotate(90)"
        >
          <g
            id="Group_4547"
            data-name="Group 4547"
            transform="translate(557 -700)"
          >
            <line
              id="Line_29"
              data-name="Line 29"
              y1="6"
              x2="7"
              transform="translate(619.5 763.5)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="1"
            />
            <line
              id="Line_30"
              data-name="Line 30"
              x2="7"
              y2="6"
              transform="translate(619.5 769.5)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="1"
            />
          </g>
          <g
            id="Group_4548"
            data-name="Group 4548"
            transform="translate(1169.5 63.5)"
          >
            <line
              id="Line_29-2"
              data-name="Line 29"
              x1="7"
              y1="6"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="1"
            />
            <line
              id="Line_30-2"
              data-name="Line 30"
              x1="7"
              y2="6"
              transform="translate(0 6)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="1"
            />
          </g>
        </g>
      </svg>
    </div>
    <ng-container *ngIf="listType === 'staff'">
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="true"
                aria-controls="collapseSeven"
              >
                {{ "filter.roles" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseSeven"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a *ngFor="let role of roles" class="dropdown-item">
                <mat-checkbox
                  [value]="role.value"
                  [checked]="role.isSelected"
                  (change)="setRoleFilter($event)"
                ></mat-checkbox>
                {{ role.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- parents and students filters -->
    <ng-container
      *ngIf="
        (listType != 'staff' &&
          listType != 'listing' &&
          listType != 'attendance-reports' &&
          listType != 'assistants' &&
          listType != 'name-sounds') ||
        (listType == 'staff' && roleFilter.includes('teacher')) ||
        (listType == 'staff' && roleFilter.includes('supervisor'))
      "
    >
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {{ "filter.grades" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a class="dropdown-item">
                <mat-checkbox
                  [(ngModel)]="allGradesIsChecked"
                  (change)="checkAll('grade')"
                >
                </mat-checkbox>
                {{ "filter.all-grades" | translate }}
              </a>
              <a *ngFor="let grade of grades" class="dropdown-item">
                <mat-checkbox
                  [checked]="allGradesIsChecked && grade.isSelected"
                  [value]="grade"
                  (change)="filterHandler('grade', $event)"
                ></mat-checkbox>
                {{ grade.name }}
              </a>
            </div>
          </div>
        </div>
        <ng-container
          *ngIf="
            (selectedGrades.length > 0 && !roleFilter.includes('supervisor')) ||
            (selectedGrades.length > 0 && roleFilter.includes('teacher'))
          "
        >
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button
                  class="btn btn-link btn-block text-left collapsed"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  {{ "filter.classes" | translate }}
                </button>
              </h2>
            </div>
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionExample"
            >
              <div class="card-body">
                <a class="dropdown-item">
                  <mat-checkbox
                    [(ngModel)]="allClassesIsChecked"
                    (change)="checkAll('class')"
                  >
                  </mat-checkbox>
                  {{ "filter.all-classes" | translate }}
                </a>
                <a *ngFor="let class of showedClasses" class="dropdown-item">
                  <mat-checkbox
                    #cb
                    [checked]="allClassesIsChecked"
                    [checked]="class.isSelected"
                    [value]="class"
                    (change)="filterHandler('class', $event)"
                  ></mat-checkbox>
                  {{ class.name }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <!-- names-sounds filter  -->
    <!-- <ng-container *ngIf="listType === 'name-sounds'">
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne"></div>
          <div class="card-body">
            <a *ngFor="let sound of sounds" class="dropdown-item">
              <mat-checkbox
                [value]="sound"
                (change)="filterHandler('sound', $event)"
              ></mat-checkbox>
              {{ sound.name | translate }}
            </a>
          </div>
        </div>
      </div>
    </ng-container> -->

    <!--attendance reports filter-->

    <div
      *ngIf="listType === 'attendance-reports' || listType === 'name-sounds'"
      class="row"
      style="padding-top: 25px"
    >
      <div class="col-12">
        <div class="filterItem-container">
          <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node
              *matTreeNodeDef="let node"
              matTreeNodeToggle
              matTreeNodePadding
            >
              <button mat-icon-button disabled></button>

              <span
                class="node-name"
                [attr.class]="node.disabled ? 'disabled' : ''"
              >
                <mat-checkbox
                  [attr.class]="node.disabled ? 'disabled' : ''"
                  [checked]="checklistSelection.isSelected(node)"
                  (change)="todoLeafItemSelectionToggle(node)"
                  [disabled]="node.disabled"
                  *ngIf="node.name != 'Roles'"
                >
                </mat-checkbox>
                <span style="margin-left: 10px; color: #2b2b2b">
                  {{ node.name }}
                </span>
              </span>
            </mat-tree-node>

            <mat-tree-node
              *matTreeNodeDef="let node; when: hasChild"
              matTreeNodePadding
            >
              <button
                mat-icon-button
                matTreeNodeToggle
                style="background-color: transparent; border: 0"
                [attr.aria-label]="'toggle ' + node.name"
              >
                <mat-icon class="mat-icon-rtl-mirror" style="color: #707070">
                  {{
                    treeControl.isExpanded(node)
                      ? "expand_more"
                      : "chevron_right"
                  }}
                </mat-icon>
              </button>

              <span
                class="node-name"
                [attr.class]="node.disabled ? 'disabled' : ''"
              >
                <mat-checkbox
                  *ngIf="node.name != 'Roles'"
                  [disabled]="node.disabled"
                  [checked]="descendantsAllSelected(node)"
                  [indeterminate]="descendantsPartiallySelected(node)"
                  (change)="todoItemSelectionToggle(node)"
                  class="checklist-leaf-node"
                >
                </mat-checkbox>
                <span style="margin-left: 10px">
                  {{ node.name }}
                </span>
              </span>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>

    <!-- delegation filter -->
    <ng-container *ngIf="listType == 'listing'">
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                {{ "filter.roles" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a *ngFor="let role of delegationRoles" class="dropdown-item">
                <mat-checkbox
                  [value]="role"
                  (change)="filterHandler('role', $event)"
                ></mat-checkbox>
                {{ role.name | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                {{ "filter.delegation.status" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseFour"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a *ngFor="let status of delegationStatus" class="dropdown-item">
                <mat-checkbox
                  [value]="status"
                  (change)="filterHandler('status', $event)"
                ></mat-checkbox>
                {{ status.name | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- parents and staff filter -->
    <ng-container *ngIf="listType == 'parents' || listType == 'staff' || listType == 'assistants'">
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                {{ "filter.activation" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a class="dropdown-item">
                <mat-checkbox
                  [checked]="activation === 1"
                  [value]="1"
                  (change)="toggleRegAndActivationFilters('activation', $event)"
                ></mat-checkbox>
                {{ "filter.activated" | translate }}
              </a>
              <a class="dropdown-item">
                <mat-checkbox
                  [checked]="activation === 0"
                  [value]="0"
                  (change)="toggleRegAndActivationFilters('activation', $event)"
                ></mat-checkbox>
                {{ "filter.not-activated" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                {{ "filter.registration" | translate }}
              </button>
            </h2>
          </div>
          <div
            id="collapseFour"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <a class="dropdown-item">
                <mat-checkbox
                  [checked]="registration === 1"
                  [value]="1"
                  (change)="
                    toggleRegAndActivationFilters('registration', $event)
                  "
                >
                </mat-checkbox>
                {{ "filter.registered" | translate }}
              </a>
              <a class="dropdown-item">
                <mat-checkbox
                  [checked]="registration === 0"
                  [value]="0"
                  (change)="
                    toggleRegAndActivationFilters('registration', $event)
                  "
                >
                </mat-checkbox>
                {{ "filter.not-registered" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="gates" *ngIf="roleFilter.includes('security')">
        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button
                  class="btn btn-link btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapseFive"
                  aria-expanded="true"
                  aria-controls="collapseFive"
                >
                  {{ "filter.gates" | translate }}
                </button>
              </h2>
            </div>
            <div
              id="collapseFive"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionExample"
            >
              <div class="card-body">
                <a *ngFor="let gate of gates" class="dropdown-item">
                  <mat-checkbox
                    [value]="gate"
                    (change)="setGateFilter($event)"
                  ></mat-checkbox>
                  {{ gate.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="listType !== 'enroll-bus-students'" class="filter-rest"></div>
</div>
